// material-ui
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { canUseOwnTransactions } from 'utils/subscriptionPlan';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

// Menu items gated by subscription plan (TRIAL excluded — see utils/subscriptionPlan.js)
const PLAN_GATED_ITEM_IDS = ['transaction-uploads'];

const applyPlanGating = (item, isEligible) => {
  if (item.type === 'group') {
    return { ...item, children: item.children.map((child) => applyPlanGating(child, isEligible)) };
  }
  if (PLAN_GATED_ITEM_IDS.includes(item.id) && !isEligible) {
    return { ...item, disabled: true, chip: { label: 'Upgrade', color: 'warning', size: 'small', variant: 'outlined' } };
  }
  return item;
};

const Navigation = () => {
  const { subscriptionPlan } = useSelector((state) => state.account);
  const isEligible = canUseOwnTransactions(subscriptionPlan);

  const navGroups = menuItem.items.map((item) => {
    const gatedItem = applyPlanGating(item, isEligible);
    switch (gatedItem.type) {
      case 'group':
        return <NavGroup key={gatedItem.id} item={gatedItem} />;
      default:
        return (
          <Typography key={gatedItem.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
};

export default Navigation;
